<template>
	<div>
		<v-tabs v-model="tab" align-with-title>
			<v-tabs-slider color="secondary"></v-tabs-slider>
			<v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
		</v-tabs>
		<keep-alive>
			<component :is="currentTabComponent" :update="update" :orgNodeList="orgNodes" @usersFetched="handleUsers"></component>
		</keep-alive>
		<v-fab-transition>
			<v-btn v-if="$can('createUser')" color="primary" class="screen-fixed" fixed right fab x-large @click="openInvite++">
				<v-icon>mdi-account-circle</v-icon>
			</v-btn>
		</v-fab-transition>
		<pvcam-wc-user :on="openInvite" :org="org" :org-name="orgName" :third-party-user="orgContainsAPIUser" :current-role="role"/>
	</div>
</template>

<script>

	import { AmplifyEventBus } from "aws-amplify-vue";

	import { ListAccessibleOrgs, GetOrgTree, ListAllRoles } from "@/services/API.js";

	import OrgUserList from "./Sections/OrgUserList.vue";
	import OrgInviteList from "./Sections/OrgInviteList.vue";

	import { Logger } from "aws-amplify";
	const logger = new Logger("Org Users");

	export default {
		components: {
			OrgUserList,
			OrgInviteList
		},
		data: () => ({
			orgNodes: [],
			update: 0,
			tab: 0,
			items: ["User List", "Pending Invites"],
			invite: false,
			loader: false,
			openInvite: 0,
			orgs: [],
			users: [],
			roles: []
		}),
		computed: {
			org() {
				if (this.$route.params.name) {
					return this.$route.params.name;
				}
				return null;
			},
			currentTabComponent: function() {
				switch (this.tab) {
					case 0:
						return "org-user-list";
					case 1:
						return "org-invite-list";
					default:
						return "org-user-list";
				}
			},
			orgName() {
				if (this.orgs.length > 0) {
					let org = this.orgs.find(org => {
						return org.id == this.org;
					});
					return org.name;
				}	
				else {
					return '';
				}
			},
			role() {
				return this.$store.state.role;
			},
			orgContainsAPIUser() {
				let hasAPIUser = this.users.find(user => user.Role.name == 'THIRD_PARTY_USER');

				return typeof hasAPIUser == 'object' ? true : false;
			}
		},
		watch: {
			orgNodes (nodesList) {
				logger.debug("nodeListUpdated admin", nodesList)
				window.EventBus.$emit('nodeListUpdated', nodesList)
			}
		},
		mounted() {
			logger.info('current state : ', this.role);
			this.getOrgs();
			this.getRoles();

			if(this.org) {
				this.getOrgNodesList(this.org)
			}
		},
		methods: {
			handleUsers(users) {
				this.users = users;
			},
			getRoles () {
				ListAllRoles().then(result => {
					// list of roles and text values to represent them
					let roles = result.Roles
					const roleDisplayNames = {
						"SYS_ADMIN": "SYS ADMIN",
						"SUPPORT_LEAD": "SUPPORT LEAD",
						"SUPPORT_ADMIN": "SUPPORT ADMIN",
						"ORG_ADMIN": "ORG ADMIN",
						"GROUP_ADMIN": "GROUP ADMIN",
						"FLEET_MANAGER": "FLEET MANAGER",
						"FIRMWARE_MANAGER": "FIRMWARE MANAGER",
						"THIRD_PARTY_USER": "API USER",
						"DRIVER": "DRIVER",
						"GEOTAB_USER": "GEOTAB USER"
					}

					// find a list of available roles for the users to assign
					let availableRoles = roles
						.filter(i => this.getRoleValue(this.role) > this.getRoleValue(i) && this.showRole(i))
						.map(i => ({value: i, text: roleDisplayNames[i] || i}))
					this.roles = availableRoles	
					window.EventBus.$emit('roleListUpdated', this.roles)

				}).catch(err => {
					logger.debug("could not find all roles", err)
				})
			},
			showRole(role) {
				// roles that should not show on the front end yet
				const hideRole = {
					DRIVER: true,
					GEOTAB_USER: true,
					test_role: true
				}

				// roles that should be able to create an API user
				const canCreateApiUser = {
					SYS_ADMIN: true,
					SUPPORT_ADMIN: true,
					SUPPORT_LEAD: true,
				}

				if(hideRole[role]) {
					return false
				}

				if(role == 'THIRD_PARTY_USER' && !canCreateApiUser[this.role]) {
					return false
				}

				return true
			},
			// returns a numerical value for a role, higher numbers are higher permision roles
			getRoleValue (role) {
				// ROLE HEIRARCHY
				const roleValues = {
					"SYS_ADMIN": 6,
					"SUPPORT_LEAD": 5,
					"FIRMWARE_MANAGER": 4,
					"SUPPORT_ADMIN": 4,
					"ORG_ADMIN": 3,
					"GROUP_ADMIN": 2,
					"FLEET_MANAGER": 1,
					"THIRD_PARTY_USER": 0,
					"DRIVER": 0,
					"GEOTAB_USER": 0
				}

				return roleValues.hasOwnProperty(role)
					? roleValues[role]
					: 0
			},
			getOrgNodesList (org) {
				GetOrgTree(org).then(res => {
					try {
						let nodesList = []
						const reduceNodes = (node) => {
							nodesList.push({ value: node.id, title: node.metadata.label })
							if(node.nodes && node.nodes.length) {
								for(let x = 0; x < node.nodes.length; x++) {
									reduceNodes(node.nodes[x])
								}
							}
						}
						reduceNodes(res.root_node)

						logger.debug("node list", nodesList)

						this.orgNodes = nodesList
						logger.debug("org tree", res)
					} catch (err) {
						logger.debug("org tree error", err)
						this.orgNodes = []
					}
				}).catch(err => {
					this.orgNodes = []
					logger.debug("org tree error", err)
				})
			},
			getOrgs() {
				ListAccessibleOrgs()
				.then(res => {
					this.orgs = res.sort((a, b) => a.name.localeCompare(b.name));
				})
				.catch(err => {
					AmplifyEventBus.$emit("snackEvent", {
						color: "error",
						text: err
					});
				});
			}
		}
	};
</script>